var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 33,
    viewBox: "0 0 37 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 24.6667L16.4583 32.8333H36.875V24.6667H24.625ZM18.6225 6.67959L0.125 25.1771V32.8333H7.78125L26.2788 14.3358L18.6225 6.67959ZM32.1996 8.415C32.9958 7.61875 32.9958 6.29167 32.1996 5.53626L27.4221 0.758756C27.0396 0.378494 26.5221 0.165054 25.9827 0.165054C25.4433 0.165054 24.9259 0.378494 24.5433 0.758756L20.8071 4.49501L28.4633 12.1513L32.1996 8.415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.6a255dfaadb4c84f392c09aeb38e10c4.svg";
export { ForwardRef as ReactComponent };